import {
  Wifi,
  ShieldCheck,
  Copy,
  Eye,
  EyeOff,
} from "lucide-react";
import { useState } from "react";
function WifiPasswords() {
  const [visiblePasswords, setVisiblePasswords] = useState({});

  const wifiNetworks = [
    {
      name: "LSP_JIO_5G",
      password: "Light@2026",
    },
    {
      name: "LSP_JIO_4G",
      password: "Lsp@2026",
    },
    {
      name: "Airtel_LSP_CONF",
      password: "Light@2026",
    },
    {
      name: "LSP TP LINK 5G",
      password: "Speed@2026",
    },
    {
      name: "ACTFIBERNET_5G",
      password: "act12345",
    },
    {
      name: "ACTFIBERNET",
      password: "act12345",
    },
  ];

  const copyPassword = (password) => {
    navigator.clipboard.writeText(password);
  };

  const togglePassword = (index) => {
    setVisiblePasswords((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="space-y-6 md:space-y-8">

      {/* HEADER */}
      <div
        className="rounded-2xl md:rounded-[32px] p-5 md:p-8 text-white"
        style={{
          background:
            "linear-gradient(135deg,#C00000 0%,#8B0000 45%,#111111 100%)",
        }}
      >
        <h1 className="text-2xl md:text-4xl font-bold">
          WiFi Networks
        </h1>

        <p className="mt-2 md:mt-3 text-sm md:text-base text-white/80">
          Company wireless network credentials.
        </p>
      </div>

      {/* NETWORKS */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">

        {wifiNetworks.map((wifi, index) => (
          <div
            key={index}
            className="
              bg-white
              rounded-2xl md:rounded-[28px]
              border
              border-gray-200
              p-4 md:p-6
              shadow-[0_4px_15px_rgb(0,0,0,0.05)]
              md:shadow-[0_8px_30px_rgb(0,0,0,0.06)]
              hover:-translate-y-1
              hover:shadow-[0_15px_40px_rgb(0,0,0,0.10)]
              transition-all
            "
          >
            <div className="flex items-center gap-3 mb-4">

              <div
                className="
                  w-10 h-10
                  md:w-12 md:h-12
                  rounded-xl
                  bg-red-100
                  flex
                  items-center
                  justify-center
                "
              >
                <Wifi
                  size={20}
                  className="text-[#C00000]"
                />
              </div>

              <div>
                <h2 className="font-bold text-base md:text-lg">
                  {wifi.name}
                </h2>

                <p className="text-xs md:text-sm text-gray-500">
                  Wireless Network
                </p>
              </div>
            </div>

            <div
              className="
                bg-gray-50
                border
                border-gray-200
                rounded-xl
                p-4
              "
            >
              <div className="flex items-center justify-between">
                <p className="text-sm text-gray-500">
                  Password
                </p>

                <div className="flex gap-2">
                  <button
                    onClick={() => togglePassword(index)}
                    className="text-gray-500 hover:text-[#C00000]"
                  >
                    {visiblePasswords[index] ? (
                      <EyeOff size={18} />
                    ) : (
                      <Eye size={18} />
                    )}
                  </button>

                  <button
                    onClick={() =>
                      copyPassword(wifi.password)
                    }
                    className="text-gray-500 hover:text-[#C00000]"
                  >
                    <Copy size={18} />
                  </button>
                </div>
              </div>

              <p className="font-semibold text-base md:text-lg text-[#C00000] mt-2 break-all">
                {visiblePasswords[index]
                  ? wifi.password
                  : "••••••••••"}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* SECURITY NOTE */}
      <div
        className="
          bg-white
          rounded-2xl md:rounded-[28px]
          p-4 md:p-6
          border
          border-gray-200
          flex
          items-start
          gap-3 md:gap-4
        "
      >
        <div className="bg-red-100 p-2 rounded-xl">
          <ShieldCheck
            className="text-[#C00000]"
            size={22}
          />
        </div>

        <div>
          <h3 className="font-semibold text-sm md:text-base">
            Security Reminder
          </h3>

          <p className="text-sm text-gray-600 mt-1">
            These credentials are intended for
            Lightspeed Photonics employees only.
            Please do not share them outside the company.
          </p>
        </div>
      </div>

    </div>
  );
}

export default WifiPasswords;